var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('application-menu',{attrs:{"app":_vm.app,"flow":_vm.flow}}),_vm._v("\n  Hello "+_vm._s(_vm.app.name)+" with "+_vm._s(_vm.flow.name)+" ("+_vm._s(_vm.flowId)+")\n  ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }